export const VERBS = [
  "act",
  "add",
  "agree",
  "allow",
  "be",
  "catch",
  "create",
  "delete",
  "discover",
  "eat",
  "explore",
  "go",
  "help",
  "imagine",
  "jump",
  "merge",
  "need",
  "offer",
  "play",
  "read",
  "run",
  "search",
  "skip",
  "solve",
  "speak",
  "think",
  "try",
  "work",
  "write",
];

export const NOUNS = [
  "city",
  "coffee",
  "courage",
  "fact",
  "family",
  "flower",
  "food",
  "friend",
  "fun",
  "hope",
  "justice",
  "key",
  "life",
  "love",
  "music",
  "smile",
  "time",
];

export const ADJECTIVES = [
  "absolute",
  "compassionate",
  "cozy",
  "dull",
  "enigmatic",
  "fascinating",
  "interesting",
  "playful",
  "predictable",
  "remarkable",
  "soothing",
  "sunny",
  "unforgettable",
  "wonderful",
];

export const ADVERBS = [
  "accidentally",
  "accommodatingly",
  "boldly",
  "briskly",
  "carefully",
  "efficiently",
  "freely",
  "gently",
  "happily",
  "lightly",
  "loudly",
  "quickly",
  "quietly",
  "suddenly",
  "unexpectedly",
  "wisely",
];

export const LONG_WORDS = [
  "Pneumonoultramicroscopicsilicovolcanoconiosis",
  "Floccinaucinihilipilification",
  "Pseudopseudohypoparathyroidism",
  "Hippopotomonstrosesquippedaliophobia",
  "Antidisestablishmentarianism",
  "Supercalifragilisticexpialidocious",
  "Honorificabilitudinitatibus",
];

export const JS_RESERVED_WORDS = [
  "abstract",
  "arguments",
  "await",
  "boolean",
  "break",
  "byte",
  "case",
  "catch",
  "char",
  "class",
  "const",
  "continue",
  "debugger",
  "default",
  "delete",
  "do",
  "double",
  "else",
  "enum*",
  "eval",
  "export",
  "extends",
  "false",
  "final",
  "finally",
  "float",
  "for",
  "function",
  "goto",
  "if",
  "implements",
  "import",
  "in",
  "instanceof",
  "int",
  "interface",
  "let",
  "long",
  "native",
  "new",
  "null",
  "package",
  "private",
  "protected",
  "public",
  "return",
  "short",
  "static",
  "super",
  "switch",
  "synchronized",
  "this",
  "throw",
  "throws",
  "transient",
  "true",
  "try",
  "typeof",
  "var",
  "void",
  "volatile",
  "while",
  "with",
  "yield",
];

export const HTML_COLOR_NAME_SAMPLES = [
  "AliceBlue",
  "Aqua",
  "Aquamarine",
  "Azure",
  "Beige",
  "Bisque",
  "Black",
  "Blue",
  "BlueViolet",
  "Brown",
  "BurlyWood",
  "CadetBlue",
  "Chartreuse",
  "Chocolate",
  "Coral",
  "DarkSlateGray",
  "DeepPink",
  "Gold",
  "Lime",
  "Olive",
  "Orchid",
  "Salmon",
  "Turquoise",
];

export const WORDS = [
  ...VERBS,
  ...NOUNS,
  ...ADJECTIVES,
  ...ADVERBS,
  ...LONG_WORDS,
];
